export default __webpack_public_path__ + "static/media/image.4b7f4986.svg";